import { Wrench, Clock, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../contexts/AuthContext";

const MaintenancePage = () => {
  const { maintenanceMessage } = useAuth();
  const detail =
    maintenanceMessage ||
    "Sistemimiz şu anda bakımda. Lütfen daha sonra tekrar deneyin.";

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass p-12 max-w-lg w-full text-center">
        <div className="w-24 h-24 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-8">
          <Wrench className="w-12 h-12 text-primary animate-pulse" />
        </div>
        
        <h1 className="text-4xl font-mono font-bold mb-4 uppercase bg-gradient-to-r from-primary to-green-400 bg-clip-text text-transparent">
          Bakımdayız
        </h1>
        
        <p className="text-lg text-muted-foreground mb-6">{detail}</p>
        
        <div className="p-4 bg-white/5 rounded-lg mb-6">
          <div className="flex items-center justify-center gap-2 text-primary mb-2">
            <Clock className="w-5 h-5" />
            <span className="font-mono font-bold">En kısa sürede aktif olacağız!</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Daha iyi bir deneyim için çalışıyoruz. Anlayışınız için teşekkür ederiz.
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-xs text-muted-foreground">
            Acil durumlarda Telegram kanalımızdan bize ulaşabilirsiniz.
          </p>
          
          <Button
            variant="outline"
            className="font-mono rounded-none"
            onClick={() => {
              window.location.href = "/login";
            }}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Yönetici girişi
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
